<template>
    <div class="input-group">
        <input type="text" placeholder="Buscar usuário " class="input form-control" v-model="wordToSearch">
        <span class="input-group-btn">
            <button type="button" class="btn btn btn-primary" @click="doSearch"><i class="fa fa-search"></i> Buscar</button>
        </span>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                wordToSearch:null,
            }
        },
        mounted(){

        },
        methods:{
            doSearch(){
                location.href = "/admin/users/search/"+this.wordToSearch;
            }
        }
    }
</script>